import React, { useState, useEffect, useRef, useContext } from 'react';
import cl from './Finances.module.css'
import Id from "../../../assets/Icon/Id";
import Mobile from "../../../assets/Icon/Mobile";
import At from "../../../assets/Icon/At";
import Vin from "../../../assets/Icon/Vin";
import Container from "../../../assets/Icon/Container";
import Auction from "../../../assets/Icon/Auction";
import Ship from "../../../assets/Icon/Ship";
import Pen from "../../../assets/Icon/Pen";
import Star from "../../../assets/Icon/Star";
import StarHalf from "../../../assets/Icon/StarHalf";
import StarFull from "../../../assets/Icon/StarFull";
import ClientPriceModal from './ClientPriceModal';
import SalerPriceModal from './SalerPriceModal';
import CompanyPriceModal from './CompanyPriceModal';
import TransactionModal from './TransactionModal/TransactionModal';
import StatusDropdown from './StatusDropdown/StatusDropdown';
import MarineLine from './MarineLine/MarineLine';
import InsuranceDropdown from './InsuranceDropdown/InsuranceDropdown';
import ServiceDropdown from './ServiceDropdown/ServiceDropdown'; 
import AutowiniInvoice from './Invoice/AutowiniInvoice';
import Contract from './Contract/Contract'; 
import Leasing from './Contract/Leasing'; 
import DeliveryAcceptance from './Contract/DeliveryAcceptance';
import InsuranceSupplement from './Contract/InsuranceSupplement';
import PrivacyPolicy from './Contract/PrivacyPolicy';
import ContractDeposit from './Contract/Deposit';
import CarDeleteModal from './DeleteModal/CarDeleteModal';
import ImageModal from './ImageModal/ImageModal';
import Flag from '../../UI/Flag/Flag';
import { AppContext } from '../../../providers/appProvider';
import DealerDebtModal from './DealerDebtModal/DealerDebtModal';
import TransactionDepositModal from './TransactionDepositModal/TransactionDepositModal ';
import ColorModal from './ColorModal/ColorModal';
import DocIssuerModal from './DocIssuer/DocIssuer';
import FinalRecipient from './FinalRecipient/FinalRecipient';
import List from "../../../assets/Icon/List";
import SenderAt from './Inputes/SenderAt/SenderAt';
import BonusDone from './Inputes/BonusDone/BonusDone'; 
import Archive from './Inputes/Archive/Archive'; 
import LondonUnderWriters from './LondonUnderwriters/Underwriters';
import { baseFileURL } from '../../../Api'; 
import AgentCRMModal from './AgentCRMModal/AgentCRMModal';

import { useTranslation } from 'react-i18next';
 

const CarItem = ({ carItem, carService, statuses, isTable, columns }) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;     


    const formatDate = (dateString) => {
        if (!dateString) {
            return "";
        }

        const purchasedAtDate = new Date(dateString);

        if (isNaN(purchasedAtDate.getTime())) {
            //console.error("Invalid date provided:", dateString);
            return "";
        }

        const months = [
            t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'),
            t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')
        ];

        const monthIndex = purchasedAtDate.getMonth();
        if (typeof monthIndex !== "number" || monthIndex < 0 || monthIndex > 11) {
            return "";
        }

        const day = purchasedAtDate.getDate();
        const month = months[monthIndex];
        const year = purchasedAtDate.getFullYear();

        return `${day} ${month} ${year}`;
    };



    const { appState, app } = useContext(AppContext);

    const [car, setCar] = useState(carItem)
    const [initialCarPrice] = useState(car.client_price_car);

    const [paidClient, setPaidClient] = useState(0)
    const [paidCompany, setPaidCompany] = useState(0)
    const [isFocused, setIsFocused] = useState(false);
    const [isFocusedTransit, setIsFocusedTransit] = useState(false);
    const [isFocusedBl, setIsFocusedBl] = useState(false);

    const [containerText, setContainerText] = useState(carItem.container_number);
    const [transitText, setTransitText] = useState(carItem.transit_number);
    const [blnumberText, setBlnumberText] = useState(carItem.bl_number);

    const [depositPaidText, setDepositPaidText] = useState("");

 
    const wrapperRef = useRef(null);
    const wrapperRefTransit = useRef(null);
    const wrapperRefBl = useRef(null);

     
    const [possibleWin, setPossibleWin] = useState(0)
    const [realWin, setRealWin] = useState(0)
    const [isDocIssuerModalOpen, setIsDocIssuerModalOpen] = useState(false);
    const [isFinalRecipientModalOpen, setIsFinalRecipientModalOpen] = useState(false);

 

 
 

    var isDesosit = car.website.id === 5

    useEffect(() => {
        if (car) { 
            const client_deposit_paid = carItem.transactions.find(transaction => transaction.is_deposit === true)
            if (client_deposit_paid) {
                setDepositPaidText(client_deposit_paid.amount)
            } else {
                setDepositPaidText(0)
            }

        }
    }, [car]);


    useEffect(() => {
        setCar(carItem)
    }, [carItem]);


    const handleWrapperFocus = () => {
        setIsFocused(true);
    };

    const handleWrapperBlur = async (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.relatedTarget)) {
            setIsFocused(false);
            carService.updateContainerNumber(carItem.id, containerText)
        }
    };


    const handleWrapperFocusTransit = () => {
        setIsFocusedTransit(true);
    };

    const handleWrapperBlurTransit = async (e) => {
        if (wrapperRefTransit.current && !wrapperRefTransit.current.contains(e.relatedTarget)) {
            setIsFocusedTransit(true);
            carService.updateTransitNumber(carItem.id, transitText)
        }
    };


    const handleWrapperFocusBl = () => {
        setIsFocusedBl(true);
    };

    const handleWrapperBlurBl = async (e) => {
        if (wrapperRefBl.current && !wrapperRefBl.current.contains(e.relatedTarget)) {
            setIsFocusedBl(true);
            carService.updateBlNumber(carItem.id, blnumberText)
        }
    };
 

    const handleInputChange = (event) => {
  
        if (car.insurance == 1) {
            app.setError("ჯერ უნდა მიუთითოთ დაზღვევის სტატუსი") 
        } else {
            setContainerText(event.target.value); 
        }

    };

    const handleInputChangeTransit = (event) => {
        setTransitText(event.target.value);
    };

    const handleInputChangeBl = (event) => {
        setBlnumberText(event.target.value);
    };
 
    const onChangeStatus = (statusId) => {
        var statusN = Number(statusId);
        setCar(prevState => ({
            ...prevState,
            status: { id: statusN },
        }));

        //carService.updateStatus(car.id, statusN);

        carService.updateStatus(car.id, statusN)
        .then(response => {
            carService.fetchCars()
        })
        .catch(error => {
            console.error(error);
        });

        if (statusId === 6) {
            setIsDocIssuerModalOpen(true)
        }
        /*carService.setFilter(prevState => ({
            ...prevState,
            all: !prevState.all,
        }));*/
    };

    const onChangeItem = (itemId) => {
        var insuranceNum = Number(itemId);
        setCar(prevState => ({
            ...prevState,
            insurance: insuranceNum,
        }));
        carService.updateInsurance(car.id, insuranceNum);
    };

    let doneclass = cl.redFin
    const tdStyles = cl.redTable;
    let doneClientclass = cl.redFin
    let redTable = {};


    if (car.company_debt <= 0) {
        doneclass = cl.greenFin
    } else {
        doneclass = cl.redFin
    }

    if (car.total_company_paid <= 0) {
        redTable = tdStyles
    }  

    if (car.client_debt <= 0) {
        doneClientclass = cl.greenFin
    } else {
        doneClientclass = cl.redFin
    }

    if (car.pwin < 0) {
        doneClientclass = cl.redFin
    }  

 



    let tdColor = {};
    if (car.color && (car.color.length > 4)) {
        tdColor = {
            backgroundColor: car.color,
        };
    }

    if (car.pwin < 0) {
        tdColor = {
            backgroundColor: 'red',
        };
    } 


    const [checked, setChecked] = useState(false);
    const [rowClass, setRowClass] = useState('');

    const handleChangeFirstCol = (event) => {
        if (checked === true) {
            setChecked(prev => !prev);
            setRowClass(cl.activeTR);
        } else {
            setChecked(prev => !prev);
            setRowClass('');
        }
    };



    const handleClickRow = () => {
        if (rowClass === '') {
            setRowClass(cl.activeTR);
        } else {
            setRowClass('');
        }
        setChecked(prev => !prev);
    };

    const handleDocIssuerSave = (personalDetails) => {
        var wholeName = personalDetails.firstname + " " + personalDetails.lastname + " " + personalDetails.personal_number
        setCar(prevState => ({
            ...prevState,
            doc_issuer: wholeName,
        }));
        carService.updateDocIssuer(car.id, wholeName)
        setIsDocIssuerModalOpen(false)
    };

    const handleFinalRecipientSave = (e) => {

        carService.updateFinalRecipient(car.id, e)
        .then((response) => {
             
                setCar(prevState => ({
                    ...prevState,
                    final_recipient_firstname: e.final_recipient_firstname,
                    final_recipient_lastname: e.final_recipient_lastname,
                    final_recipient_personal: e.final_recipient_personal,
                    final_recipient_mobile: e.final_recipient_mobile,
                }));

                carService.fetchCars();
 
        })
        .catch((error) => {
            app.setError(`შეცდომა დამატებისას: ${error.message}`);
            carService.fetchCars();

        });


 
        carService.updateFinalRecipient(car.id, e)
        
        setIsFinalRecipientModalOpen(false)
    };


    const [savedRow, setSavedRow] = useState(null);

    const savedItemFunction = (carItemId) => {
        setSavedRow(carItemId);
    };

  const sources = [

    { value: 4, label: t('Bitrix') },
    { value: 2, label:  t('CalledCity') },
    { value: 1, label: t('AutovinSite')},
    { value: 3, label: t('CameToOffice') },
    { value: 7, label: t('OldClient') },
    { value: 5, label: t('Recommendation') },
    { value: 6, label: t('OutdoorAd') },
    { value: 8, label:  t('Unknown') },
  ];
  

    /* insurance */
    const insurances = [
        { id: 1, name: t('MustBeInsured'), color: "#ccc" },
        { id: 2, name: t('Insured'), color: "#16a085" },
        { id: 3, name: t('NotInsured'), color: "#d80228" },
    ];

    const insurancesOptions = insurances.map((status) => ({ value: status.id, label: status.name, color: status.color }));


    const [showDropdownInsurance, setShowDropdownInsurance] = useState(null);
    const dropdownInsuranceRef = useRef(null);

    const toggleInsurance = (containerId) => {
        if (showDropdownInsurance === containerId) {
            setShowDropdownInsurance(null);
        } else {
            setShowDropdownInsurance(containerId);
        }
    }; 
    /* insurance */




    /* statuses */

    const statusLabels = {
            2: { ka: 'ნაყიდია',                en: 'Purchased',             ru: 'Куплено' },
            3: { ka: 'მიყვანილია საწყობში',    en: 'Delivered to warehouse',ru: 'Доставлено на склад' },
            4: { ka: 'ჩატვირთულია',             en: 'Loaded',                ru: 'Загружено' },
            5: { ka: 'დასრულებულია',           en: 'Completed',             ru: 'Завершено' },
            6: { ka: 'საბუთი გაცემულია',       en: 'Documents issued',      ru: 'Документы выданы' },
            7: { ka: 'შემოვიდა პორტში',       en: 'Arrived at port',       ru: 'Прибыло в порт' },
            1: { ka: 'ინვოისი გამოწერილია',    en: 'Invoice issued',        ru: 'Счёт выставлен' },
            8: { ka: 'თანხის უკან დაბრუნება',  en: 'Refunded',              ru: 'Возврат средств' },
            9: { ka: 'Ჩანაცვლდა',             en: 'Replaced',              ru: 'Замена' },
            10: { ka: 'რელისტი',             en: 'Relist',              ru: 'Релист' },
            11: { ka: 'არ რეალიზდა',             en: 'Not Realized',              ru: 'Не реализовано' },
        };

        const StatusOptions = statuses.map(status => ({
        value: status.id,
        label: statusLabels[status.id]?.[lang] ?? status.name,
        color: status.color,
        }));
 
   //const StatusOptions = statuses.map((status) => ({ value: status.id, label: status.name, color: status.color }));

    /* statuses */

    const [showDropdownStatus, setShowDropdownStatus] = useState(null);
    const dropdownStatusRef = useRef(null);
    const toggleStatus = (containerId) => {
        if (showDropdownStatus === containerId) {
            setShowDropdownStatus(null);
        } else {
            setShowDropdownStatus(containerId);
        }
    };


 




    const [openedDropdownId, setOpenedDropdownId] = useState(null);
    const dropdownRef = useRef(null);

    const toggleDropdown = (containerId) => {
        if (openedDropdownId === containerId) {
            setOpenedDropdownId(null);
        } else {
            setOpenedDropdownId(containerId);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownInsuranceRef.current && !dropdownInsuranceRef.current.contains(event.target)) {
                setShowDropdownInsurance(null);
            }
            if (dropdownStatusRef.current && !dropdownStatusRef.current.contains(event.target)) {
                setShowDropdownStatus(null);
            } 
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                if (!event.srcElement.nodeName.includes('svg')) {
                    setOpenedDropdownId(null);
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

 
    if (isTable) {

        return <tr className={redTable + ' ' + rowClass  + ' '+ ( car.pwin < 0 ? cl.pwinMinusColot : '') }  onClick={handleClickRow} style={tdColor} >
            <td className={cl.id + ' ' + cl.stickyCol} >

                <div className={cl.formCheck}>
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={handleChangeFirstCol}
                        id={'toggleRow' + car.id}
                    />
                    <label htmlFor={'toggleRow' + car.id} ></label>
                </div>

            </td>

            {columns.id && <td onClick={setSavedRow} className={carItem.id === savedRow ? cl.savedRow + ' ' + cl.id + ' ' + cl.stickyColSecond + ' ' : ' ' + cl.id + ' ' + cl.stickyColSecond} >
                <b>  {car.id}{car.lot !== undefined ? '/' + car.lot : ''}</b>
            </td>}
            {columns.purchased && <td> <b>{formatDate(car.purchased_at)}</b></td>}
            {columns.sender_at && <td> <b>{formatDate(car.sender_at)}</b></td>}
            {columns.reciever_at && <td> <b>{formatDate(car.reciever_at)}</b></td>}

            {columns.website && <td><b>{car.website.name}</b></td>}
            {app.hasPermission("CAR_AGENT_SHOW") && columns.agentcrm && <td><AgentCRMModal car={car} /></td>}
            {columns.export_country && <td><b>{car.export_country && car.export_country.name}</b></td>}

            {columns.sender && <td><b>{car.transport_price && car.transport_price.location_country ? (
                car.transport_price.location_country.name
            ) : (
                'N/A'
            )}       </b></td>}
            {columns.reciever && <td><b>{car.reciever_country && car.reciever_country.name}</b></td>}
            {columns.car && <td><b>{car.prod_year && car.prod_year} {car.maker && car.maker.name} {car.model && car.model.name}</b></td>}
            {columns.vin && <td><b>{car.vin}</b></td>}
            {columns.client && <td><b>{car.client?.firstname} {car.client?.lastname}</b></td>}
            {columns.contact && <td><b>{car.client?.mobile}</b></td>}
            {columns.saler && <td><b>{car.saler.firstname} {car.saler.lastname}</b></td>}
            {
                columns.dealer && (
                    <td>
                        <b>{car.dealer ? `${car.dealer.firstname} ${car.dealer.lastname}` : ''}</b>
                    </td>
                )
            }

            {columns.bl_number &&
                <td>

                    {(car.is_archive ? app.hasPermission("FINANCE_ARCHIVE_EDIT") : app.hasPermission("BLNUMBER_EDIT")) && !car.is_deleted
                        ? <div
                            ref={wrapperRefBl}
                            onFocus={handleWrapperFocusBl}
                            onBlur={handleWrapperBlurBl}
                            tabIndex="-1"
                            className={cl.transitDiv}
                        >
                            <input type="text" value={blnumberText} onChange={handleInputChangeBl} />
                        </div>
                        : <div>
                            {transitText}
                        </div>
                    }

                </td>
            }
 

            {columns.container &&
                <td>

                    {(car.is_archive ? app.hasPermission("FINANCE_ARCHIVE_EDIT") : app.hasPermission("CONTAINER_EDIT")) && !car.is_deleted
                        ? <>
                            <SenderAt 
                                        key={car.id}
                                        carService={carService}
                                        CarID={car.id} 
                                        ValuePar={car.sender_at}   
                            />    
                            </>
                        : <>
                            {formatDate(car.sender_at)}
                        </>
                    }

                </td>
            }


            
 

            {columns.container &&
                <td>

                    {(car.is_archive ? app.hasPermission("FINANCE_ARCHIVE_EDIT") : app.hasPermission("CONTAINER_EDIT")) && !car.is_deleted
                        ? <div
                            ref={wrapperRef}
                            onFocus={handleWrapperFocus}
                            onBlur={handleWrapperBlur}
                            tabIndex="-1"
                            className={cl.containerDiv}
                        >
                            <input type="text" value={containerText} onChange={handleInputChange} />
                        </div>
                        : <div>
                            {containerText}
                        </div>
                    }

                </td>
            }




            {columns.marine_line &&
                <td style={{ padding: '0 7px' }}> 
                    <MarineLine carService={ carService } defaultCar={car} ></MarineLine>
                </td>
            }


            {columns.transit &&
                <td>

                    {(car.is_archive ? app.hasPermission("FINANCE_ARCHIVE_EDIT") : app.hasPermission("TRANSIT_EDIT")) && !car.is_deleted
                        ? <div
                            ref={wrapperRefTransit}
                            onFocus={handleWrapperFocusTransit}
                            onBlur={handleWrapperBlurTransit}
                            tabIndex="-1"
                            className={cl.transitDiv}
                        >
                            <input type="text" value={transitText} onChange={handleInputChangeTransit} />
                        </div>
                        : <div>
                            {transitText}
                        </div>
                    }

                </td>
            }

      
            {app.hasPermission("INSURANCE_SHOW") && columns.insurance &&
                <td style={{ padding: '0 5px' }}>
                    {showDropdownInsurance === car.id ? (
                        <div ref={dropdownInsuranceRef}>
                            <InsuranceDropdown onChangeItem={onChangeItem}
                                defaultItem={car.insurance}
                                isDisabled={
                                    !(car.is_archive ? app.hasPermission("FINANCE_ARCHIVE_EDIT") : app.hasPermission("INSURANCE_EDIT")) ||
                                    car.is_deleted
                                } onCloseEditInsurance={() => { toggleInsurance(null); }} ></InsuranceDropdown>
                        </div>

                    ) : (
                        <>

                            {insurancesOptions.map((option) => (
                                <>
                                    {option.value === car.insurance &&
                                        <div onClick={() => toggleInsurance(car.id)} key={option.value} style={{ backgroundColor: '#fff', display: 'flex', alignItems: 'center', border: '1px solid var(--border-color)', borderRadius: 5, fontSize: '12px', padding: '1px 3px', height: 22 }}  >
                                            <div style={{ background: option.color, borderRadius: 50, content: ' ', display: 'block', marginRight: 4, height: 10, width: 10 }}></div>
                                            {option.value === car.insurance ? `${option.label}` : option.label}
                                        </div>
                                    }
                                </>
                            ))}
                        </>

                    )}

                </td>
            }

            {app.hasPermission("SOURCE_SELL_CHANNEL_SHOW") &&

                <td style={{ padding: '0 5px' }}>
                    {sources.map((option) => (
                        <>
                            {option.value === car.source_id &&
                                <b key={option.value} > 
                                    {option.value === car.source_id ? `${option.label}` : option.label}
                                </b>
                            }
                        </>
                    ))} 
                </td>
            }


            {app.hasPermission("CLIENT_PRICE_SHOW") &&
                <td style={{ padding: '0' }}>
                    <div className={cl.payTableVeiw + ' nonintable'}>
                        
                        <ClientPriceModal carService={carService} defaultCar={car} setDefaultCar={setCar}
                            onSave={() => savedItemFunction(carItem.id)}
                        ></ClientPriceModal>
                        
                    </div>
 

                </td>
            }

            {app.hasPermission("SALER_PRICE_SHOW") &&
                <td style={{ padding: '0' }}>
                    <div className={cl.payTableVeiw + ' nonintable'}>
                        <SalerPriceModal onSave={() => savedItemFunction(carItem.id)} carService={carService} defaultCar={car} setDefaultCar={setCar}></SalerPriceModal>
                    </div>
                </td>
            }


            {app.hasPermission("CLIENT_PAID_SHOW") &&
                <td style={{ padding: '0' }}>
                    <div className={cl.payTableVeiw + ' nonintable'}>
                        <TransactionModal onSave={() => savedItemFunction(carItem.id)} car={car} setCar={setCar} typeId={1} paid={paidClient} carService={carService}  ></TransactionModal>
                    </div>
                </td>
            }




            {app.hasPermission("DEPOSIT_SHOW") &&
                <td style={{ padding: '0' }}>
                    <div className={cl.payTableVeiw + ' nonintable'}>
                        <TransactionDepositModal car={car} setCar={setCar} typeId={1} paid={paidClient} carService={carService}  ></TransactionDepositModal>
                    </div>
                </td>
            }




            {
                app.hasPermission("DEALER_PRICE_SHOW") &&
                <td style={{ padding: '0 7px' }}>
                    {car.dealer && car.dealer.id &&
                        <div className={cl.payTableVeiw + ' nonintable'}>
                            <DealerDebtModal carId={car.id} dealerId={car.dealer.id} amount={car.client_price_dealer + car.client_price_dealer_transport} carService={carService} ></DealerDebtModal>
                        </div>
                    }

                </td>
            }

            {app.hasPermission("CLIENT_DISCOUNT") && columns.client_discount && <td><b>{car.client_price_discount}</b></td>}


            {app.hasPermission("CLIENT_DEBT_SHOW") &&
                <td style={{ padding: '0' }}>
                    <div className={cl.payTableVeiw + ' nonintable'}>
                        <div className={cl.financeBox + ' ' + doneClientclass} style={{ cursor: 'unset' }} >
                            <div className={cl.financeDesc + ' nonetable'}>
                                {/* <Client/> */} {t('Debt')} </div>
                            <div className={cl.financeValue}>
                                {(car.client_debt > 0 ? car.client_debt : (car.client_debt < 0 ? '' + car.client_debt * -1 : '0'))}
                                
                            </div>
                        </div>
                    </div>
                </td>
            }



            {app.hasPermission("COMPANY_PRICE_SHOW") &&
                <td style={{ padding: '0' }}>
                    <div className={cl.payTableVeiw + ' nonintable'}>
                    
                        <CompanyPriceModal onSave={() => savedItemFunction(carItem.id)} carService={carService} defaultCar={car} setDefaultCar={setCar}></CompanyPriceModal>
                        
                    </div>
                </td>
            }



            {app.hasPermission("COMPANY_PAID_SHOW") &&
                <td style={{ padding: '0' }}>
                    <div className={cl.payTableVeiw + ' nonintable'}>
                        <TransactionModal onSave={() => savedItemFunction(carItem.id)} car={car} setCar={setCar} typeId={2} paid={paidCompany} carService={carService} ></TransactionModal>
                    </div>
                </td>
            }





            {app.hasPermission("COMPANY_DEBT_SHOW") &&
                <td style={{ padding: '0' }}>
                    <div className={cl.payTableVeiw + ' nonintable'} >
                        <div className={cl.financeBox + ' ' + doneclass} style={{ cursor: 'unset' }}>
                            <div className={cl.financeDesc + ' nonetable'}> {t('Debt')} </div>
                            <div className={cl.financeValue}>
                                {(car.company_debt > 0 ? car.company_debt : (car.company_debt < 0 ? '' + car.company_debt * -1 : '0'))}
                            </div>
                        </div>
                    </div>
                </td>
            }




            {app.hasPermission("BONUS_SHOW") &&

                <>

                    <td style={{ padding: '0' }}>
                        <div style={{ display: 'flex' }}>
                            <div className={cl.payTableVeiw + ' nonintable'}>
                                <div className={cl.financeBox} style={{ cursor: 'unset' }} >
                                    <div className={cl.financeDesc + ' nonetable'}> ბონუსი </div>
                                    <div className={cl.financeValue}> 
                                        {car.bonus !== 0 ? car.bonus : ''}
                                    </div>
                                </div>
                            </div>  
                        </div>
                    </td>

                    {app.hasPermission("BONUS_DONE") &&
                        <td style={{ padding: '0' }}>
                            <div style={{ display: 'flex' }}> 
                                {app.hasPermission("BONUS_DONE") && car.client_debt <= 0 && car.company_debt <= 0 && 
                                <>
                                    <BonusDone
                                        key={car.id}
                                        carService={carService}  
                                        carID={car.id}   
                                        carBonusDate={car.bonus_done_date}   
                                        value={car.bonus_done}   
                                    />
                                </> 
                                } 
                            </div>
                        </td>
                    }
                    

                </>
            
            }

            {app.hasPermission("FUND_CALC_SHOW") && columns.percent &&
                <td style={{ padding: '0' }}>

                    {((car.client_price_fund * car.client_percent_fund) / 100 > 0 && car.fund_accept == 1 ? 
                        
                        <div className={cl.payTableVeiw + ' nonintable'}>
                            <div className={cl.financeBox} style={{ cursor: 'unset' }} >
                                <div className={cl.financeDesc + ' nonetable'}>{t('Procent')}</div>
                                <div className={cl.financeValue}>
                                    {(car.client_real_percent !== 0 ? car.client_real_percent : ' ')}
                                </div>
                            </div>
                        </div>
                    : 
                        <div className={cl.payTableVeiw + ' nonintable'}>
                            <div className={cl.financeBox} style={{ cursor: 'unset' }} >
                                <div className={cl.financeDesc + ' nonetable'}>{t('Procent')}</div>
                                <div className={cl.financeValue} style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>

                                    {((car.client_price_fund * car.client_percent_fund) / 100 !== 0 ? (car.client_price_fund * car.client_percent_fund) / 100 : ' ')}
                                    
                                    {((car.client_price_fund * car.client_percent_fund) / 100 !== 0 ? <span style={{ backgroundColor: 'rgb(216, 2, 40)', borderRadius: '50%', color: 'white', display: 'flex', height: '16px', width: '16px', alignItems: 'center', fontWeight: 'bold', justifyContent: 'center'  }}>!</span> : ' ')}
                                    {(car.total_client_paid <  car.client_price_car ? <span style={{ backgroundColor: 'rgb(216, 2, 40)', borderRadius: '50px', padding: '10px 9px', color: 'white', display: 'flex', height: '16px', width: 'unset', alignItems: 'center', fontWeight: 'bold', justifyContent: 'center'  }}>{t('Problem')}</span> : ' ')}

                                </div>
                            </div>
                        </div>
                    )}
                     

                     
                    
                </td>
            }

            {app.hasPermission("CLIENT_DISCOUNT") && columns.client_discount && <td><b>{car.car_price_discount}</b></td>}

            {app.hasPermission("STATUS_SHOW") && columns.status &&
                <td style={{ padding: '0 7px' }}>

                    {showDropdownStatus === car.id ? (
                        <div ref={dropdownStatusRef}>
                            <StatusDropdown statuses={statuses} defaultStatus={car.status} onChangeStatus={onChangeStatus}
                                isDisabled={
                                    !(car.is_archive ? app.hasPermission("FINANCE_ARCHIVE_EDIT") : app.hasPermission("STATUS_EDIT")) ||
                                    car.is_deleted
                                }
                                onCloseEditStatus={() => { toggleStatus(null); }}></StatusDropdown>
                        </div>

                    ) : (
                        <>
                            {StatusOptions.map((option) => (
                                <>
                                    {option.value === car.status.id &&
                                        <div onClick={() => toggleStatus(car.id)} key={option.value} style={{ backgroundColor: '#fff', display: 'flex', alignItems: 'center', border: '1px solid var(--border-color)', borderRadius: 5, fontSize: '12px', padding: '1px 3px', height: 22 }}  >
                                            <div style={{ background: option.color, borderRadius: 50, content: ' ', display: 'block', marginRight: 4, height: 10, width: 10 }}></div>
                                            {option.value === car.status.id ? `${option.label}` : option.label}
                                        </div>
                                    }
                                </>
                            ))}
                        </>

                    )}


                </td>
            }


            {app.hasPermission("DOC_ISSUER_SHOW") && columns.doc_issue &&
                <td style={{ padding: '0 7px' }}>
                    <div className={cl.payTableVeiw + ' nonintable'}>
                        <DocIssuerModal
                            isOpen={isDocIssuerModalOpen}
                            onClose={() => setIsDocIssuerModalOpen(false)}
                            onSave={handleDocIssuerSave}
                            open={setIsDocIssuerModalOpen}
                            car={car}
                        />
                    </div>
                </td>
            }

            {app.hasPermission("FINAL_RECIPIENT_SHOW") && columns.final_recipient &&
                <td style={{ padding: '0 7px' }}>
                    <div className={cl.payTableVeiw + ' nonintable'}>
                        <FinalRecipient
                            isOpen={isFinalRecipientModalOpen}
                            onClose={() => setIsFinalRecipientModalOpen(false) && carService.fetchCars() }
                            onSave={handleFinalRecipientSave}
                            open={setIsFinalRecipientModalOpen}
                            car={car}
                        />
                    </div>
                </td>
            }


            {app.hasPermission("PWIN_SHOW") &&
                <td style={{ padding: '0' }}>
                    <div className={cl.payTableVeiw + ' nonintable'}>
                        <div
                            className={cl.financeBox + (possibleWin > 0 ? ` ${cl.greenFin}` : (possibleWin < 0 ? ` ${cl.redFin}` : ''))}
                            style={{ cursor: 'unset' }}
                        >
                            <div className={cl.financeDesc + ' nonetable'}> {t('PlannedProfit')}</div>
                            <div className={cl.financeValue}>
                                {(car.pwin !== 0 ? car.pwin : ' ')}
                            </div>
                        </div>
                    </div>
                </td>
            }




            {app.hasPermission("RWIN_SHOW") &&
                <td>
                    <div className={cl.payTableVeiw + ' nonintable'}>
                        <div
                            className={cl.financeBox + (realWin > 0 ? ` ${cl.greenFin}` : (realWin < 0 ? ` ${cl.redFin}` : ''))}
                            style={{ cursor: 'unset' }}
                        >
                            <div className={cl.financeDesc + ' nonetable'}> {t('RealProfit')}</div>
                            <div className={cl.financeValue}>
                                {(car.rwin !== 0 ? car.rwin : ' ')}
                            </div>
                        </div>
                    </div>
                </td>
            }

 
            {columns.archive && app.hasPermission("ARCHIVE_UPDATE") &&

                <td style={{ padding: '0', textAlign: 'center' }}> 
                        <>
                            <Archive
                                key={car.id}
                                carService={carService}  
                                carID={car.id}     
                                value={car.is_archive}   
                            />
                        </>
  
                </td>
            }
 
          


            {columns.feedback && app.hasPermission("FEEDBACK_SHOW") &&

                <td style={{ padding: '0px 2px', textAlign: 'center' }}>

                    <a
                        href={`/car-rate/${car.id}`} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className={cl.editBtn} >
                            {car.feedback_id === 0 && car.feedback_service_id === 0 ? (
                                <Star />
                            ) : car.feedback_id !== 0 && car.feedback_service_id !== 0 ? (
                                <StarFull style={{ color: 'green' }} />
                            ) : (
                                <StarHalf  style={{ color: 'green' }} />
                            )} 
                        {t('Feedback')}
                    </a> 
  
                </td>
            }



            <td className={cl.btntbl + ' ' + cl.stickyColLast }>
                <div className={cl.btns}>
                    <>
 
                        <div className={cl.navItemBox} >

                            <div className={cl.navItemBtn} onClick={() => toggleDropdown(car.id)}>
                                <List /> {t('Navigation')}
                            </div>

                            {openedDropdownId === car.id && (
                                <div className={cl.dropdownContent + ' ' + cl.dropdownContentInverse} ref={dropdownRef}>

                            {(() => {
                                
                                const fundAmount = (car.client_price_fund * car.client_percent_fund) / 100;
                                const showInvoice = fundAmount <= 0 || car.fund_accept === 1;

                                if (car.client) {
                                    return showInvoice ? (
                                        <AutowiniInvoice
                                            carItem={car}
                                            discountAccept={car.discount_accept}
                                            websiteItem={car.website}
                                            clientItem={car.client}
                                        />
                                    ) : null;
                                } else {
                                    return showInvoice ? (
                                        <AutowiniInvoice
                                            carItem={car}
                                            discountAccept={car.discount_accept}
                                            websiteItem={car.website}
                                            clientItem={car.client}
                                        />
                                    ) : null;
                                }

                            })()}

                                      
                                            <>
                                                {car.website.id === 5 ? <ContractDeposit carItem={car} /> : <Contract carItem={car} />}
                                                <Leasing carItem={car} />
                                                <InsuranceSupplement carItem={car} />
                                                <LondonUnderWriters carItem={car} />
                                                <PrivacyPolicy carItem={car} />
                                                <DeliveryAcceptance carItem={car} />
                                            </>
                                        



                                    {
                                        (car.is_archive ? app.hasPermission("FINANCE_ARCHIVE_EDIT") : app.hasPermission("PICTURE_SHOW")) &&
                                        !car.is_deleted &&
                                        <ImageModal carService={carService} defaultCar={car} isBtn={true} />
                                    }
                               {
                                    (car.is_archive ? app.hasPermission("FINANCE_ARCHIVE_EDIT") : app.hasPermission("FINANCE_EDIT")) &&
                                    !car.is_deleted && (
                                    <>
                                    { /* <EditCarModal onSave={() => savedItemFunction(car.id)} carService={carService} defaultCar={car} /> */ }
                                        
                                        <a
                                            href={`/finances/edit/${car.id}`} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            className={cl.editBtn} >
                                            <Pen/> { t('EditFinance')}   
                                        </a>

                                        
                                    </>
                                    )
                                }
                                 
                                    <ColorModal carService={carService} car={car} />

                                    {
                                        (car.is_archive ? app.hasPermission("FINANCE_ARCHIVE_EDIT") : app.hasPermission("FINANCE_DELETE")) &&
                                        !car.is_deleted &&
                                        <CarDeleteModal carService={carService} defaultCar={car} />
                                    }

                                </div>
                            )}
                        </div>



                    </>

                </div>
            </td>
        </tr>
    } else {

        return <div>
            <div className={cl.flexList}>
                <div className={cl.item}>
                    <div className={cl.Car}>
                        <div className={cl.incar}>

                            <ImageModal carService={carService} defaultCar={car}></ImageModal>

                            <div className={cl.carDesc}>
                                <div className={cl.carName}>
                                    {car.prod_year && car.prod_year} {car.maker && car.maker.name} {car.model && car.model.name}
                                </div>
                                <div className={cl.carDetail}>
                                    <ul>
                                        <li className={cl.copied + ' ' + cl.upcase}><Vin />{car.vin}</li>
                                        <li>{formatDate(car.purchased_at)}</li>

                                    </ul>
                                    <ul>
                                        <li>{car.website.name}</li>
                                        <li> <Auction />{car.lot}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={cl.client}>
                        <div className={cl.clientDesc}>
                            <div className={cl.clientName}>
                                {car.client?.firstname} {car.client?.lastname}
                            </div>
                            <div className={cl.clientDetail}>
                                <ul>
                                    <li><Mobile />{car.client?.mobile}</li>
                                    <li><Id />{car.client?.personal}</li>
                                    <li><At />{car.client?.email}</li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div className={cl.tranBox}>

                        <div className={cl.transport}>

                            <div className={cl.locationSender}>
                                {car.transport_price && car.transport_price.location_country ? (
                                    <Flag countryCode={car.transport_price.location_country.code}> </Flag>
                                ) : (
                                    ''
                                )}
                            </div>

                            <div className={cl.tranDesc} >
                                <ul>
                                    {car.marine_line && car.marine_line.name &&
                                        <li><Ship />{car.marine_line.name}</li>}

                                    {car.container_number &&
                                        <li><Container />{car.container_number}</li>}

                                </ul>
                                <div className={cl.line}></div>
                                <ul className={cl.arrauvul}>
                                    <li>{car.sender_at ? formatDate(car.sender_at) : ''}</li>
                                    <li>{car.reciever_at ? formatDate(car.reciever_at) : ''}</li>

                                </ul>
                            </div>

                            <div className={cl.locationReciever}>
                                <Flag countryCode={car.reciever_country && car.reciever_country.code}> </Flag>
                            </div>
                        </div>

                        <div className={cl.billingBox}> 

                            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}> 

                                {app.hasPermission("INSURANCE_SHOW") &&
                                    <>

                                        {showDropdownInsurance === car.id ? (
                                            <div ref={dropdownInsuranceRef}>
                                                <InsuranceDropdown onChangeItem={onChangeItem}
                                                    defaultItem={car.insurance}
                                                    isDisabled={
                                                        !(car.is_archive ? app.hasPermission("FINANCE_ARCHIVE_EDIT") : app.hasPermission("INSURANCE_EDIT")) ||
                                                        car.is_deleted
                                                    } onCloseEditInsurance={() => { toggleInsurance(null); }} ></InsuranceDropdown>
                                            </div>

                                        ) : (
                                            <>

                                                {insurancesOptions.map((option) => (
                                                    <>
                                                        {option.value === car.insurance &&
                                                            <div onClick={() => toggleInsurance(car.id)} key={option.value} style={{ backgroundColor: '#fff', display: 'flex', alignItems: 'center', border: '1px solid var(--border-color)', borderRadius: 5, fontSize: '12px', padding: '1px 3px', height: 22 }}  >
                                                                <div style={{ background: option.color, borderRadius: 50, content: ' ', display: 'block', marginRight: 4, height: 10, width: 10 }}></div>
                                                                {option.value === car.insurance ? `${option.label}` : option.label}
                                                            </div>
                                                        }
                                                    </>
                                                ))}
                                            </>

                                        )}


                                    </>
                                }

                                {app.hasPermission("STATUS_SHOW") &&
                                    <>

                                        {showDropdownStatus === car.id ? (
                                            <div ref={dropdownStatusRef}>
                                                <StatusDropdown statuses={statuses} defaultStatus={car.status} onChangeStatus={onChangeStatus}
                                                    isDisabled={
                                                        !(car.is_archive ? app.hasPermission("FINANCE_ARCHIVE_EDIT") : app.hasPermission("STATUS_EDIT")) ||
                                                        car.is_deleted
                                                    }
                                                    onCloseEditStatus={() => { toggleStatus(null); }}></StatusDropdown>
                                            </div>

                                        ) : (
                                            <>
                                                {StatusOptions.map((option) => (
                                                    <>
                                                        {option.value === car.status.id &&
                                                            <div onClick={() => toggleStatus(car.id)} key={option.value} style={{ whiteSpace: 'nowrap', backgroundColor: '#fff', display: 'flex', alignItems: 'center', border: '1px solid var(--border-color)', borderRadius: 5, fontSize: '12px', padding: '1px 3px', height: 22 }}  >
                                                                <div style={{  background: option.color, borderRadius: 50, content: ' ', display: 'block', marginRight: 4, height: 10, width: 10 }}></div>
                                                                {option.value === car.status.id ? `${option.label}` : option.label}
                                                            </div>
                                                        }
                                                    </>
                                                ))}
                                            </>

                                        )}


                                    </>

                                }  



                            </div>
  
                                 {app.hasPermission("SERVICE_EDIT") &&  
                                    <> 
                                        <ServiceDropdown carService={carService} car={car}></ServiceDropdown>                                              
                                    </>
                                }

 
                        </div>
 


                    </div>

                    <div className={cl.salerFinance}>

                        <div className={cl.priceValueB + ' ' + cl.centerBorder} style={{ width: '50%', maxWidth: '50%', minWidth: '50%' }}>

                            {app.hasPermission("CLIENT_PRICE_SHOW") &&
                                <ClientPriceModal carService={carService} defaultCar={car} setDefaultCar={setCar}  ></ClientPriceModal>
                            }
                            {app.hasPermission("CLIENT_PAID_SHOW") &&
                                <TransactionModal carService={carService} car={car} setCar={setCar} typeId={1} paid={paidClient} ></TransactionModal>

                            }
                            {app.hasPermission("CLIENT_DEBT_SHOW") &&
                                <div className={cl.financeBox + ' ' + doneClientclass}  >
                                    <div className={cl.financeDesc}>   {/*    <Client /> */} {t('Debt')} </div>
                                    <div className={cl.financeValue}> {car.client_debt} $</div>
                                </div>
                            }

                        </div>



                        <div className={cl.priceValueB} style={{ width: '50%', maxWidth: '50%', minWidth: '50%', }}>

                            {app.hasPermission("COMPANY_PRICE_SHOW") &&
                                <CompanyPriceModal carService={carService} defaultCar={car} setDefaultCar={setCar}></CompanyPriceModal>
                            }

                            {app.hasPermission("COMPANY_PAID_SHOW") &&
                                <TransactionModal carService={carService} car={car} setCar={setCar} typeId={2} paid={car.total_company_paid} ></TransactionModal>
                            }

                            {app.hasPermission("COMPANY_DEBT_SHOW") &&
                                <div className={cl.financeBox + ' ' + doneclass}  >
                                    <div className={cl.financeDesc}> {t('Debt')} </div>
                                    <div className={cl.financeValue}> {car.company_debt} $</div>
                                </div>
                            }

                        </div>


                    </div>

                    <div className={cl.Finances}>



                        <div className={cl.footerbtnio}>

                            <div className={cl.navItemBtn}  >
                                {car.id}{car.lot !== undefined ? '/' + car.lot : ''}
                            </div>

                                    {baseFileURL === 'https://finance.automoby.ge' ? 
                                        ((car.client_price_fund * car.client_percent_fund) / 100 > 0 ?
                                            car.fund_accept == 1 ?
                                                <AutowiniInvoice carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />
                                            :
                                                ''
                                            :
                                            <AutowiniInvoice carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />)
                                        :
                                        ((car.client_price_fund * car.client_percent_fund) / 100 > 0 ?
                                        car.fund_accept == 1 ?
                                            <AutowiniInvoice carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />
                                        :
                                            ''
                                        :
                                        <AutowiniInvoice carItem={car} discountAccept={car.discount_accept}  websiteItem={car.website} clientItem={car.client} />)
                                    } 

                           
                                    {car.website.id === 5 ? <ContractDeposit carItem={car} /> : <Contract carItem={car} />}
                                    <InsuranceSupplement carItem={car} />
                                    <PrivacyPolicy carItem={car} />
                                    <LondonUnderWriters carItem={car} />
                                    <DeliveryAcceptance carItem={car} />  

                                    {
                                         
                                        (app.hasPermission("FINANCE_EDIT_IF_CAR_PRICE_0")  && initialCarPrice == 0)&& ( 
                                            <a
                                                href={`/finances/edit/${car.id}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                className={cl.editBtn} >
                                                <Pen/> { t('EditFinance')}     
                                            </a> 
                                        )
                                    }

                                 


                            {app.hasPermission("SOURCE_SELL_CHANNEL_SHOW") &&
                                <span className={cl.sourceLabel} >
                                    {sources.map((option) => (
                                        <>
                                            {option.value === car.source_id &&
                                                <span key={option.value} > 
                                                    {option.value === car.source_id ? `${option.label}` : option.label}
                                                </span>
                                            }
                                        </>
                                    ))} 
                                </span>
                            }





                        </div>

                        <div  className={cl.footerbtnio} >


                        
                            


                            {app.hasPermission("BONUS_SHOW") &&
                                <>
                                
                                    <div className={cl.financeBox} >
                                        <div className={cl.financeDesc}> {t('Bonus')} </div>
                                        <div className={cl.financeValue}>
                                            {(isDesosit === true) || ((isDesosit === false) && (car.client_debt > 0)) ? 0 : car.bonus} $
                                        </div>
                                    </div> 
                                </>
                            }

                            {app.hasPermission("PWIN_SHOW") &&
                                <div
                                    className={cl.financeBox + (possibleWin > 0 ? ` ${cl.greenFin}` : (possibleWin < 0 ? ` ${cl.redFin}` : ''))}>
                                    <div className={cl.financeDesc}> {t('PlannedProfit')}</div>
                                    <div className={cl.financeValue}> {car.pwin} $</div>
                                </div>
                            }


                            {app.hasPermission("RWIN_SHOW") &&
                                <div
                                    className={cl.financeBox + (realWin > 0 ? ` ${cl.greenFin}` : (realWin < 0 ? ` ${cl.redFin}` : ''))}>
                                    <div className={cl.financeDesc}>{t('RealProfit')}</div>
                                    <div className={cl.financeValue}> {car.rwin} $</div>
                                </div>
                            }


                        </div>

                    </div>
                </div>
            </div>
 
        </div>;

    }

}

export default CarItem;
